import { WorksheetBatchUpdateDefinition } from '..';
import {
  WorksheetBatchUpdateCommonDefaultParams,
  WorksheetBatchUpdateCommonQueryFields,
  WorksheetBatchUpdateCommonRequiredParams,
} from '../Core/SharedQueryFields';
import {
  AsDynamicConePenetrometerWorksheetFields,
  AsDynamicConePenetrometerWorksheetSections,
} from './AsDynamicConePenetrometerWorksheetFields';

const AsDynamicConePenetrometerBatchUpdateDefinition: WorksheetBatchUpdateDefinition = {
  worksheetType: 'Dynamic Cone Penetrometer',
  query: {
    defaultParams: WorksheetBatchUpdateCommonDefaultParams,
    requiredParams: WorksheetBatchUpdateCommonRequiredParams,
  },
  queryFields: WorksheetBatchUpdateCommonQueryFields,
  worksheetFields: AsDynamicConePenetrometerWorksheetFields,
  worksheetFieldSections: AsDynamicConePenetrometerWorksheetSections,
};

export default AsDynamicConePenetrometerBatchUpdateDefinition;

export { AsDynamicConePenetrometerBatchUpdateDefinition };
